import { logger } from '@talos/kyoko';
import canceledSoundSrc from './sounds/canceled.mp3';
import coinsSoundSrc from './sounds/coins.mp3';
import rejectedSoundSrc from './sounds/rejected.mp3';
import rfqFirstPriceBackSoundSrc from './sounds/rfqFirstPriceBack.mp3';
import rfqNewQuoteUpdatedQuoteSoundSrc from './sounds/rfqNewQuoteUpdatedQuote.mp3';
import swipeSoundSrc from './sounds/swipe.mp3';

const coinsSound = new Audio(coinsSoundSrc);
coinsSound.volume = 0.5;
const rejectedSound = new Audio(rejectedSoundSrc);
rejectedSound.volume = 0.6;
const canceledSound = new Audio(canceledSoundSrc);
canceledSound.volume = 0.4;
const swipeSound = new Audio(swipeSoundSrc);
swipeSound.volume = 0.3;
const rfqFirstPriceBackSound = new Audio(rfqFirstPriceBackSoundSrc);
rfqFirstPriceBackSound.volume = 0.4;
const rfqNewQuoteUpdatedQuoteSound = new Audio(rfqNewQuoteUpdatedQuoteSoundSrc);
rfqNewQuoteUpdatedQuoteSound.volume = 0.4;

export const SoundMap = {
  Coins: coinsSound,
  Rejected: rejectedSound,
  Canceled: canceledSound,
  Swipe: swipeSound,
  RFQ_FirstPriceBack: rfqFirstPriceBackSound,
  RFQ_NewQuoteUpdatedQuote: rfqNewQuoteUpdatedQuoteSound,
} as const;

export const playSound = (sound: keyof typeof SoundMap) => {
  SoundMap[sound].play().catch(error => {
    logger.warn(`Failed to play sound: ${sound}`, {
      context: { errorMessage: error instanceof Error ? error.message : 'Unknown error', error },
    });
  });
};
